<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div [formGroup]="formGroup">
	<div *ngIf="includeFilter">
		<div *ngIf="multiSelect">
			<!-- ############################################################################### -->
			<!-- #######################  [x] Filter,  [x] Multi-Select  ####################### -->
			<!-- ############################################################################### -->
			<mat-form-field [class]="extClass" [subscriptSizing]="subScriptSizing">
				<mat-error *ngIf="matFilterMultiSelectControl.hasError('required')">{{
					strings.FIELD_IS_REQUIRED
				}}</mat-error>
				<mat-hint *ngIf="hint">{{ hint }}</mat-hint>
				<mat-label *ngIf="placeholder">{{ labelToDisplay }}</mat-label>
				<mat-select
					#filteredMultiSelect
					multiple
					[placeholder]="labelToDisplay"
					automationId="matFilterMultiSelectControl"
					name="matFilterMultiSelectControl"
					formControlName="matFilterMultiSelectControl"
					(click)="handleFilteredMultiSelectClick(filteredMultiSelect, searchInput)"
					(openedChange)="handleFilterMultiSelectOpenedChange(filteredMultiSelect)"
					[disableOptionCentering]="true"
					(closed)="handleFilterMultiSelectClosed()"
				>
					<div class="box-search">
						<mat-checkbox
							*ngIf="showSelectAllCheckbox"
							class="box-select-all"
							automationId="selectAllChecked"
							formControlName="selectAllChecked"
							(change)="toggleSelectAll($event)"
						></mat-checkbox>
						<input
							#searchInput
							type="text"
							automationId="searchPlaceholder"
							name="filterMultiSelectTextControl"
							formControlName="filterMultiSelectTextControl"
							[placeholder]="searchPlaceholder"
						/>
						<div
							*ngIf="searchInput.value.trim() !== ''"
							(click)="formGroup.controls['filterMultiSelectTextControl'].setValue('')"
						>
							<button mat-icon-button class="clear-filter-icon">
								<mat-icon class="mat-24" aria-label="Clear filter">clear</mat-icon>
							</button>
						</div>
					</div>
					<mat-select-trigger>
						<ng-container [ngTemplateOutlet]="multiSelectTriggerContents"></ng-container>
					</mat-select-trigger>
					<mat-option
						*ngFor="let option of allOption$ | async"
						[value]="option.label"
						[style.display]="option.matchesFilter ? 'flex' : 'none'"
					>
						<ng-container
							[ngTemplateOutlet]="optionContents"
							[ngTemplateOutletContext]="{ option: option }"
						></ng-container>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<!-- *ngIf="multiSelect" -->

		<div *ngIf="!multiSelect">
			<!-- ############################################################################### -->
			<!-- #######################  [x] Filter,  [ ] Multi-Select  ####################### -->
			<!-- ############################################################################### -->
			<mat-form-field [class]="extClass" [subscriptSizing]="subScriptSizing">
				<mat-error *ngIf="filterTextControl.hasError('required')">{{ strings.FIELD_IS_REQUIRED }}</mat-error>
				<mat-hint *ngIf="hint">{{ hint }}</mat-hint>
				<mat-label *ngIf="placeholder">{{ labelToDisplay }}</mat-label>
				<input
					#filterText
					type="text"
					matInput
					class="remove-old-textarea-styling"
					(click)="handleFilterTextClick(filterText)"
					name="filterTextControl"
					formControlName="filterTextControl"
					automationId="filterTextControl"
					[matAutocomplete]="auto"
				/>
				<mat-icon matSuffix>arrow_drop_down</mat-icon>
				<mat-autocomplete #matAutocomplete #auto="matAutocomplete">
					<mat-option *ngIf="includeNotSetOption" [value]="notSet_internalValue">
						<ng-container [ngTemplateOutlet]="notSetOptionContents"></ng-container>
					</mat-option>
					<mat-option
						*ngFor="let option of allOption$ | async"
						[value]="option.label"
						[style.display]="option.matchesFilter ? 'flex' : 'none'"
					>
						<ng-container
							[ngTemplateOutlet]="optionContents"
							[ngTemplateOutletContext]="{ option: option }"
						></ng-container>
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</div>
		<!-- *ngIf="(! multiSelect)" -->
	</div>
	<!-- *ngIf="(! includeFilter)" -->

	<div *ngIf="!includeFilter">
		<!--
			You might think you could simplify the following two <div>s and their *ngIf's that depend on "multiSelect",
			since they only vary in that one includes a "multiple" attribute in its <mat-select> and the other does not.
			You might THINK you could have a single <mat-select [attr.multiple]="multiSelect ? '' : null"
			but you'd be wrong: that DOES NOT WORK.
		-->
		<div *ngIf="multiSelect">
			<!-- ############################################################################### -->
			<!-- #######################  [ ] Filter,  [x] Multi-Select  ####################### -->
			<!-- ############################################################################### -->
			<mat-form-field [class]="extClass" [subscriptSizing]="subScriptSizing">
				<mat-error *ngIf="matMultiSelectControl.hasError('required')">{{
					strings.FIELD_IS_REQUIRED
				}}</mat-error>
				<mat-hint *ngIf="hint">{{ hint }}</mat-hint>
				<mat-label *ngIf="placeholder">{{ labelToDisplay }}</mat-label>
				<mat-select
					[placeholder]="labelToDisplay"
					name="matMultiSelectControl"
					formControlName="matMultiSelectControl"
					[disableOptionCentering]="true"
					multiple
				>
					<mat-select-trigger>
						<ng-container [ngTemplateOutlet]="multiSelectTriggerContents"></ng-container>
					</mat-select-trigger>
					<mat-option
						*ngFor="let option of allOption$ | async"
						[value]="option.label"
						[style.display]="option.matchesFilter ? 'flex' : 'none'"
					>
						<ng-container
							[ngTemplateOutlet]="optionContents"
							[ngTemplateOutletContext]="{ option: option }"
						></ng-container>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<!-- *ngIf="multiSelect" -->

		<div *ngIf="!multiSelect">
			<!-- ############################################################################### -->
			<!-- #######################  [ ] Filter,  [ ] Multi-Select  ####################### -->
			<!-- ############################################################################### -->
			<mat-form-field [class]="extClass" [subscriptSizing]="subScriptSizing">
				<mat-error *ngIf="matSelectControl.hasError('required')">{{ strings.FIELD_IS_REQUIRED }}</mat-error>
				<mat-hint *ngIf="hint">{{ hint }}</mat-hint>
				<mat-label *ngIf="placeholder">{{ labelToDisplay }}</mat-label>
				<mat-select
					[placeholder]="overridablePlaceholder"
					name="matSelectControl"
					formControlName="matSelectControl"
					[disableOptionCentering]="true"
				>
					<mat-option *ngIf="includeNotSetOption" [value]="notSet_internalValue">
						<ng-container [ngTemplateOutlet]="notSetOptionContents"></ng-container>
					</mat-option>
					<mat-option
						*ngFor="let option of allOption$ | async"
						[value]="option.label"
						[style.display]="option.matchesFilter ? 'flex' : 'none'"
					>
						<ng-container
							[ngTemplateOutlet]="optionContents"
							[ngTemplateOutletContext]="{ option: option }"
						></ng-container>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<!-- *ngIf="(! multiSelect)" -->
	</div>
	<!-- *ngIf="(! includeFilter)" -->
</div>

<ng-template #multiSelectTriggerContents>
	<span *ngIf="!this.customSelectionSummaryFunction && selection?.length > 1" class="selection-count-text">
		({{ selection.length }})
	</span>
	{{ selectionSummaryText() }}
</ng-template>

<ng-template #notSetOptionContents let-option="option">
	<div class="select-div">
		{{ notSetLabel }}
	</div>
</ng-template>

<ng-template #optionContents let-option="option">
	<div class="select-div">
		<mat-icon
			*ngIf="option.iconColor"
			class="select-icon"
			[ngStyle]="{ background: option.iconColor }"
		></mat-icon>
		<span class="option-text">{{ option.displayedLabel }}</span>
	</div>
</ng-template>
